import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'temps-winds-aloft-legend-svg',
  templateUrl: './temps_winds_aloft_legend.svg',
  styleUrl: '../../../../../../../twc-legend/shared-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class TempsWindsAloftSvgComponent {}
